import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { createLinkFailure, createLinkSuccess } from "domains/createShareSettings/actions";
import type { CreateInviteLinkDefaultAction } from "domains/createShareSettings/actionTypes";
import type { TopicAccessInvitePost, TopicAccessInviteResponse } from "domains/topicshare/topicshare.types";

export function* createLinkSaga({ meta }: CreateInviteLinkDefaultAction) {
  try {
    const { permission, topic_id } = meta;
    const body: TopicAccessInvitePost = { permission };
    const payload: TopicAccessInviteResponse = yield apiFetch(`topic/${topic_id}/access/invite_token`, {
      body,
      method: "POST",
    });
    yield put(createLinkSuccess(payload, meta));
  } catch {
    yield put(createLinkFailure(meta));
  }
}
